import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AccessToken, OauthService } from 'src/app/oauth.service';
import { environment } from 'src/environments/environment';
import { OutlookAuthService } from './outlook-auth.service';

@Component({
  selector: 'app-outlook-auth-lp',
  templateUrl: './outlook-auth-lp.component.html',
  styleUrls: ['./outlook-auth-lp.component.css']
})
export class OutlookAuthLpComponent implements OnInit, OnDestroy{
  urlParams = null;
  auth_code: string = null;
  access_token: string = null;
  tokenNotified = false;
  tokenError = false;
  constructor(
    private route: ActivatedRoute,
    private outlookService: OutlookAuthService
  ) {
    this.outlookService.tokenError.subscribe(
      param => {
        if(!!param) {
          let origin = localStorage.getItem("origin");
          this.outlookService.notifyTokenError(origin, param.error).subscribe(
            () => this.tokenError = true
          )
        }
      }
    )
  }

  ngOnInit(): void {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get('code');
    this.route.queryParams.subscribe(
      params => {
        if(Object.entries(params).length > 0 && !code) {
          this.urlParams = params;
          localStorage.setItem("origin", params["redirect_uri"]);
          if(!!params["client_id"]) localStorage.setItem("client_id", params["client_id"]);
          if(!!params["client_secret"]) localStorage.setItem("client_secret", params["client_secret"]);
          this.redirectToKeycloak(params);
        }
        if(code) {
          this.auth_code = code;
          this.fetchAccessToken(code, params);
        }
      }
    )
  }

  private fetchAccessToken(code: string, params) {
    this.outlookService.getAccessToken(code, params).subscribe(
      res => {
        this.access_token = res.access_token;
        this.notify(res);
      }
    );
  }

  notify(payload) {
    // let body = {auth: [payload]}; /// mock only
    let urlOrigin = localStorage.getItem("origin");
    this.outlookService.notifyTokenObtained(urlOrigin, payload).subscribe(
      () => {
        localStorage.removeItem("client_id");
        localStorage.removeItem("client_secret");
        localStorage.removeItem("origin");
        this.tokenNotified = true;
      }
    )
  }

  private redirectToKeycloak(params) {
    const { url, realm, outlookAuthEndpoint} = environment.keycloak;
    const clientSecret = params["client_secret"] ? params["client_secret"] : environment.keycloak.clientSecret;
    const clientId = params["client_id"] ? params["client_id"] : environment.keycloak.clientId;
    const origin = params["redirect_uri"];
    const defaultIDP = "ms-fake";
    const encodedOrigin = encodeURIComponent(origin);
    const authUrl = `${url}/realms/${realm}/protocol/openid-connect/auth` +
                    `?kc_idp_hint=${defaultIDP}&response_type=code&client_id=${clientId}&client_secret=${clientSecret}&redirect_uri=${encodeURIComponent(outlookAuthEndpoint)}`;
    window.location.href = authUrl;
  }

  ngOnDestroy(): void {
    localStorage.removeItem("client_id");
    localStorage.removeItem("client_secret");
    localStorage.removeItem("origin");
  }

}
